import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import isNil from 'lodash/isNil';
import AmountField from '../../../staticFields/AmountField';
import TextHr from '../../../TextHr';
import useCurrentAmountAndCreditBalance from '../../../../../shared/utils/currentAmountAndCreditBalance/useCurrentAmountAndCreditBalance';
import CommonOrderAmountsItems from '../OrderAmounts/CommonOrderAmountsItems';

const OrderAmountsWithPartingLine = ({
  trackingCallback,
  isShowBlankCol, fieldConfig,
}) => {
  const {
    entities: {
      orderInfo: {
        currencyCode,
        totalAmount, paidAmount,
        remainingBalance, ...rest
      },
    },
  } = useSelector(state => state.mainStateData);

  const {
    amountDue,
    paymentProcessingFee,
  } = useSelector(state => state.paymentOptions);

  const { yourPayment, currentCreditBalance } = useCurrentAmountAndCreditBalance();

  return (
    <div className="order-detail__content-amount with-ppf">
      <CommonOrderAmountsItems
        currencyCode={currencyCode}
        fieldConfig={fieldConfig}
        isShowBlankCol={isShowBlankCol}
        trackingCallback={trackingCallback}
        {...rest} />
      <AmountField label="checkout.lib.components.text.orderTotal"
        price={totalAmount}
        className="order-detail__content-amount__total"
        currencyCode={currencyCode}
        {...fieldConfig}
        isShowBlankCol={isShowBlankCol}/>
      <TextHr />
      <AmountField label="checkout.lib.components.orderDetailContent.paidAmount"
        price={paidAmount}
        currencyCode={currencyCode}/>
      <AmountField label="checkout.lib.components.orderDetailContent.remainingBalance"
        price={remainingBalance}
        className="order-detail__content-amount__remainbalance"
        currencyCode={currencyCode}/>
      {
        !isNil(amountDue) && <>
          <TextHr />
          { currentCreditBalance > 0 && <AmountField
            label="checkout.lib.components.text.creditBalanceApplied"
            price={0 - currentCreditBalance}
            currencyCode={currencyCode}
            {...fieldConfig}
            isShowBlankCol={isShowBlankCol}/>}
          {paymentProcessingFee > 0 && <AmountField
            label="checkout.lib.components.text.currentPPF"
            price={paymentProcessingFee}
            currencyCode={currencyCode}
            {...fieldConfig}
            isShowBlankCol={isShowBlankCol}/>}
          <AmountField label="checkout.lib.components.orderSummary.yourPayment"
            price={yourPayment}
            className="order-detail__content-amount__yourPayment"
            currencyCode={currencyCode}
            {...fieldConfig}
            isShowBlankCol={isShowBlankCol}/>
        </>
      }
    </div>
  );
};

export default memo(OrderAmountsWithPartingLine);
